// Copyright (c) 2026 WiseTime. All rights reserved.

import { fromEvent, Observable, partition } from "rxjs"
import { shareReplay } from "rxjs/operators"

export type VisibilityChange = () => {
  pageVisible$: Observable<Event>,
  pageHidden$: Observable<Event>,
}
export const visibilityChange: VisibilityChange = () => {
  const [pageVisible$, pageHidden$] = partition(
    fromEvent(document, "visibilitychange").pipe(
      shareReplay({ refCount: true, bufferSize: 1 })
    ),
    () => document.visibilityState === "visible",
  )
  return { pageVisible$, pageHidden$ }
}
